'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sidebar from 'ContentEditorUI/components/sidebar/Sidebar';
import AppReadyContainer from 'ContentEditorUI/containers/AppReadyContainer';
import { getActiveSidebarPanel, getIsSidebarExpanded, getSidebarPanels, getSidebarIframeNeedsLoadingIndicator, getPatagoniaSidebarIframeVisible } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { openPanel, closePanel } from 'ContentEditorUI/redux/actions/panelActions';
import { getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { clearInpageUIState } from 'ContentEditorUI/redux/actions/inpageActions';
import { SIDEBAR_PANELS, APPLY_CHANGES_PORTAL_SELECTOR } from 'ContentEditorUI/lib/sidebar/constants';
import { getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { routeToPage as routeToPageAction } from 'ContentEditorUI/redux/actions/routingActions';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  selectedModuleName: getSelectedModuleName(state),
  isOpen: getIsSidebarExpanded(state),
  panels: getSidebarPanels(state),
  currentStep: getRoutingCurrentPage(state),
  isReadOnlyMode: getIsReadOnlyMode(state),
  hasUndoRedoAccess: getHasUndoRedoAccess(state),
  sidebarIframeIsVisible: getPatagoniaSidebarIframeVisible(state),
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state),
  sidebarIframeNeedsLoadingIndicator: getSidebarIframeNeedsLoadingIndicator(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state)
});
const mapDispatchToProps = {
  onOpen: openPanel,
  onClose: closePanel,
  clearInpageUIState,
  routeToPage: routeToPageAction
};
class SidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.handleOpen = nextPanel => {
      const {
        activePanel,
        selectedModuleName,
        currentStep,
        onOpen
      } = this.props;
      let event;
      if (nextPanel === SIDEBAR_PANELS.addWidget) {
        event = 'Clicked Add';
      } else if (nextPanel === SIDEBAR_PANELS.widgetList) {
        event = 'Clicked Contents';
      } else if (nextPanel === SIDEBAR_PANELS.design) {
        event = 'Clicked Design';
      } else {
        throw new Error('Unknown sidebar panel, cannot send usage tracking');
      }
      UsageTracker.trackEditorInteraction({
        action: 'Sidebar Action',
        event
      });
      const panelChanged = nextPanel !== activePanel;
      const someSidebarPanelIsOpening = panelChanged && nextPanel;
      const shouldResetSelection = panelChanged && activePanel === SIDEBAR_PANELS.edit;
      const navigateToContentTab = someSidebarPanelIsOpening && currentStep !== 'content';
      this.props.clearInpageUIState({
        selectedModuleName: shouldResetSelection ? null : selectedModuleName
      });
      if (navigateToContentTab) {
        this.props.routeToPage('content');
      }
      onOpen(nextPanel);
    };
    this.handleClose = () => {
      const {
        onClose,
        activePanel
      } = this.props;
      onClose(activePanel);
      this.props.clearInpageUIState();
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      applyChangesButtonContainer: document.getElementById(APPLY_CHANGES_PORTAL_SELECTOR)
    };
  }
  componentDidMount() {
    if (!this.state.applyChangesButtonContainer) {
      const applyChangesButtonContainer = document.createElement('div');
      applyChangesButtonContainer.setAttribute('id', APPLY_CHANGES_PORTAL_SELECTOR);
      document.body.appendChild(applyChangesButtonContainer);
      this.setState({
        applyChangesButtonContainer
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      activePanel,
      currentTab,
      routeToPage,
      selectedModuleName
    } = this.props;

    // If we are not already on the content tab and an action just selected a module to edit
    // change route to `/content`
    if (currentTab.id !== 'content' && currentTab.id !== 'preview' && selectedModuleName && selectedModuleName !== prevProps.selectedModuleName) {
      routeToPage('content');
    } else if (currentTab.id !== 'optimize' && activePanel === SIDEBAR_PANELS.optimizer && prevProps.activePanel !== SIDEBAR_PANELS.optimizer) {
      // Hackily route to the optimize tab again after selecting and blurring a module when on optimize
      // (an issue because there are awkwardly two sources of truth, the route in the URL and the
      // the sidebar state)
      routeToPage('optimize');
    }
  }
  componentWillUnmount() {
    const {
      applyChangesButtonContainer
    } = this.state;
    const {
      isUngatedForPatagonia
    } = this.props;
    if (applyChangesButtonContainer && !isUngatedForPatagonia) {
      document.body.removeChild(applyChangesButtonContainer);
    }
  }

  // Note, used in non-Baymax only

  render() {
    const {
      activePanel,
      children,
      currentTab,
      isOpen,
      panels,
      panelsOverride,
      showAddTab,
      showDesignTab,
      isReadOnlyMode,
      hasUndoRedoAccess,
      hasAnyContainerOrDndAreaToAddModules,
      headerLabel,
      showDeviceToggle,
      sidebarIframeIsVisible,
      sidebarIframeNeedsLoadingIndicator,
      isUngatedForPatagonia
    } = this.props;
    let panel = activePanel;
    let open = isOpen;
    if (currentTab) {
      open = currentTab.showSidebar;
    }
    if (!hasAnyContainerOrDndAreaToAddModules && panel === SIDEBAR_PANELS.addWidget) {
      panel = SIDEBAR_PANELS.widgetList;
    }
    return /*#__PURE__*/_jsx(AppReadyContainer, {
      children: /*#__PURE__*/_jsx(Sidebar, {
        isOpen: open,
        panels: panelsOverride || panels,
        activePanel: panel,
        currentTab: currentTab,
        onOpen: this.handleOpen,
        onClose: this.handleClose,
        showAddTab: showAddTab,
        showDesignTab: showDesignTab,
        isReadOnlyMode: isReadOnlyMode,
        showUndoRedoButtons: hasUndoRedoAccess,
        hasAnyContainerOrDndAreaToAddModules: hasAnyContainerOrDndAreaToAddModules,
        headerLabel: headerLabel,
        showDeviceToggle: showDeviceToggle,
        sidebarIframeIsVisible: sidebarIframeIsVisible,
        sidebarIframeNeedsLoadingIndicator: sidebarIframeNeedsLoadingIndicator,
        isPatagonia: isUngatedForPatagonia,
        children: children
      })
    });
  }
}
SidebarContainer.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string.isRequired,
  currentTab: PropTypes.object,
  // New editor only
  selectedModuleName: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  panels: PropTypes.array.isRequired,
  panelsOverride: PropTypes.array,
  clearInpageUIState: PropTypes.func.isRequired,
  currentStep: PropTypes.string.isRequired,
  routeToPage: PropTypes.func.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  hasAnyContainerOrDndAreaToAddModules: PropTypes.bool.isRequired,
  headerLabel: PropTypes.node,
  showAddTab: PropTypes.bool.isRequired,
  showDesignTab: PropTypes.bool.isRequired,
  sidebarIframeIsVisible: PropTypes.bool.isRequired,
  showDeviceToggle: PropTypes.bool.isRequired,
  sidebarIframeNeedsLoadingIndicator: PropTypes.bool.isRequired,
  isUngatedForPatagonia: PropTypes.bool
};
SidebarContainer.defaultProps = {
  showAddTab: false,
  showDesignTab: false,
  showDeviceToggle: false
};
export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);